<template>
    <div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>申请业务单元</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.custComName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>服务商</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.servicerName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>同商户申请</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.custMerchantFlag == 1 ? '是' : '否'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>仓库名称</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.warehouseName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>总数量</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.totalQuantity || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请人</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.applicantName || "无"}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请时间</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.applyTime || "无"}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请状态</label>
                </div>
                <div class="form-value">
                    <span v-if="adjustApplyFormInfo.applyState == 0">未申请</span>
                    <span v-if="adjustApplyFormInfo.applyState == 1">已申请</span>
                    <span v-if="adjustApplyFormInfo.applyState == 2">已处理</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>申请备注</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.applyDesc || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核人：</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.auditorName || "无"}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核时间</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.auditTime || "无"}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核状态</label>
                </div>
                <div class="form-value">
                    <span v-if="adjustApplyFormInfo.auditState == 0">未审核</span>
                    <span v-if="adjustApplyFormInfo.auditState == 1">审核通过</span>
                    <span v-if="adjustApplyFormInfo.auditState == -1">审核未通过</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核备注</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.auditDesc || '无'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.createTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>备货用途</label>
                </div>
                <div class="form-value">
                    <span>{{accPreStkUsageMap[adjustApplyFormInfo.accPreStkUsage]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>差异数量</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.deltaQuantity || 0}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>差异说明</label>
                </div>
                <div class="form-value">
                    <span>{{adjustApplyFormInfo.deltaDesc || '无'}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>配件信息</span>
        </div>
        <div class="table-layout">
            <el-table :data="adjustApplyFormInfo.itemList" border style="width: 100%">
                <el-table-column prop="accName" label="配件名称" align="left" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.specificFlag">个</el-tag>
                        <span>{{scope.row.accName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="catName" label="分类" width="120" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="brandName" label="品牌" width="120" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="modelSpec" label="规格" width="120" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="quantity" label="申请数量" width="100" align="right"></el-table-column>
                <el-table-column prop="modelSpec" label="审核数量" width="100" align="right">
                    <template slot-scope="rows">
                        <span v-if="adjustApplyFormInfo.auditState == 1">{{rows.row.quantity + rows.row.delta}}</span>
                        <span v-else>0</span>
                    </template>
                </el-table-column>
                <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
                <el-table-column v-if="adjustApplyFormInfo.auditState == 1" prop="price" label="单价(元)" width="100" align="right"></el-table-column>
                <el-table-column prop="memo" label="申请描述" width="120" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'
    //
    import shareAccApi from '../../api/shareAcc'
    //
    export default {
        name: 'swb-adjust-apply-form-info',
        desc: '共享配件调配单详情',
        props: ['formId'],
        data: function () {
            return {
                adjustApplyFormInfo: {},
                accPreStkUsageMap: getEnumMap("accPreStkUsage", "value2text")
            }
        },
        created: function () {
            //
            this.getShareAccAdjustApplyFormInfo();
        },
        methods: {
            getShareAccAdjustApplyFormInfo: function () {
                let self = this;
                let postData = {
                    id: self.formId,
                };
                let theLoad = MsgBox.loading();
                shareAccApi.getShareAccAdjustApplyFormById(postData, function (result) {
                    theLoad.close();
                    if(result.type == 'info') {
                        //
                        self.adjustApplyFormInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shareAcc/AdjustApplyFormInfo.vue